import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';
import { delayedCallbackExecution } from 'src/utils/delayed-callback-execution';
import { unblockSpace } from '../lib/spaces';
import { spacesKeys } from '../query-keys/spaces';
import { UnblockSpacePayload } from '../types/payload/unblock-space.payload';

export const useUnblockSpace = (onSuccess?: () => void) => {
  const { t } = useTranslation(['spaces', 'common']);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      spaceToken,
      payload,
    }: {
      spaceToken: string;
      payload: UnblockSpacePayload;
    }) => unblockSpace(spaceToken, payload),
    onSuccess: () => {
      delayedCallbackExecution(1000, () => {
        queryClient.invalidateQueries({
          queryKey: spacesKeys.lists(),
        });
      });

      toast.success(t('spaces:common.unblockSpaceDialog.successMessage'));

      onSuccess?.();
    },
    onError: (error: ApiError) => {
      toast.error(
        error?.response?.data?.message ||
          t('common:errorMessages.somethingWentWrong'),
      );
    },
  });
};
